// Utility for CSRF token management for Trading Mall
// Handles fetch, store, refresh, and expiry logic
import { isBrowser } from "./common-utils";

const serviceDomain = process.env.NEXT_PUBLIC_WEB_SERVICES_DOMAIN;
const CSRF_TOKEN_KEY = "tradingMallCsrfToken";
const CSRF_TOKEN_TIMESTAMP_KEY = "tradingMallCsrfTokenFetchedAt";
const CSRF_TOKEN_EXPIRY_MS = 30 * 60 * 1000; // 30 minutes

const CSRF_API_URL = // to be replaced with the actual API endpoint
  isBrowser() ? `${serviceDomain}/api/v1/csrf` : "";

export async function fetchAndStoreCsrfToken() {
  if (!CSRF_API_URL) return null;
  try {
    const res = await fetch(CSRF_API_URL, { credentials: "include" });
    const data = await res.json();
    const token = data?.data?._csrf;
    if (token) {
      sessionStorage.setItem(CSRF_TOKEN_KEY, token);
      sessionStorage.setItem(CSRF_TOKEN_TIMESTAMP_KEY, Date.now().toString());
      return token;
    }
  } catch (e) {
    // ignore
  }
  return null;
}

export function getStoredCsrfToken() {
  if (!isBrowser()) return null;
  const token = sessionStorage.getItem(CSRF_TOKEN_KEY);
  const ts = sessionStorage.getItem(CSRF_TOKEN_TIMESTAMP_KEY);
  if (!token || !ts) return null;
  if (Date.now() - Number(ts) > CSRF_TOKEN_EXPIRY_MS) {
    sessionStorage.removeItem(CSRF_TOKEN_KEY);
    sessionStorage.removeItem(CSRF_TOKEN_TIMESTAMP_KEY);
    return null;
  }
  return token;
}

export async function getValidCsrfToken(forceRefresh = false) {
  if (forceRefresh) {
    return await fetchAndStoreCsrfToken();
  }
  const token = getStoredCsrfToken();
  if (token) return token;
  return await fetchAndStoreCsrfToken();
}

export function clearCsrfToken() {
  sessionStorage.removeItem(CSRF_TOKEN_KEY);
  sessionStorage.removeItem(CSRF_TOKEN_TIMESTAMP_KEY);
}

export async function prefetchCsrfToken() {
  await fetchAndStoreCsrfToken();
}
